import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import {
  LOCAL_PRETTY_DATETIME_FORMAT,
  LOCAL_TIMEZONE,
} from 'lib_ts/enums/datetime.enums';

// all dates in the MachineStatus section use the format below
export const formatDate = (date?: string) =>
  date
    ? format(parseISO(date), LOCAL_PRETTY_DATETIME_FORMAT, {
        timeZone: LOCAL_TIMEZONE,
      })
    : '';
